// extracted by mini-css-extract-plugin
module.exports = {"percentItem":"PercentileHorizontal_percentItem__VGBEQ","percentBar":"PercentileHorizontal_percentBar__1jeIK"};